import { Property } from '@qpr/components/Properties/views/properties-view-model';
import { useLocation } from 'react-router-dom';

const usePropertyViewAttributes = () => {
  const { search } = useLocation();
  const queryString = new URLSearchParams(search);

  const attributes = queryString.getAll('attributes');

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const parseAttributes = (attributes: string): Property[] => {
    const result: Property[] = [];
    const regexp = new RegExp(
      '(?<name>[\\wåäöÅÄÖ. ]+)(\\(as=\\"(?<alias>[\\wåäöÅÄÖ ]+)\\"\\))?',
      'gi'
    );
    let match = regexp.exec(attributes);
    while (match !== null) {
      result.push({
        attributeName: match.groups?.name || '',
        viewName: match.groups?.alias ? match.groups?.alias : match.groups?.name
      });
      match = regexp.exec(attributes);
    }
    return result;
  };

  const attributeInfo = parseAttributes(attributes.join(','));

  return attributeInfo;
};

export default usePropertyViewAttributes;
